import http from 'plugins/axios'

export default {
  list(data) {
    return http.get({
      url: '/ta/admin/tenant/welfare/user/task/list',
      data,
    })
  },
  updateStatus(data) {
    return http.post({
      url: '/ta/admin/tenant/welfare/user/task/updateEnableStatus',
      data,
    })
  },
}
